import { useEffect } from 'react';
import { useStableEventHandler } from '../use-stable-event-handler';
import { createSingletonHandler } from '../use-singleton-handler';
var useMutationSingleton = createSingletonHandler(function (handler) {
    var observer = new MutationObserver(function () { return handler(); });
    observer.observe(document.body, { attributes: true, subtree: true });
    return function () { return observer.disconnect(); };
});
export function useMutationObserver(elementRef, onChange) {
    var handler = useStableEventHandler(function () {
        if (elementRef.current) {
            onChange(elementRef.current);
        }
    });
    useMutationSingleton(handler);
    useEffect(function () {
        handler();
    }, [handler]);
}
//# sourceMappingURL=index.js.map